export enum TalentPoolsScope {
  Default = 'not_archived',
  Archived = 'archived',
}
